import { patternFormatter } from 'react-number-format';
import { PHONE_FORMAT } from './formatted-phone-input';

export const formatToPhoneNumber = (value: string) => {
  return patternFormatter(value, { format: PHONE_FORMAT });
};
